class CartEvents {

  constructor() {
    this.listeners();
    this.body = document.querySelector('body');
  }

  listeners () {
    document.addEventListener('cart:add', (e) => {
      if (this.body.classList.contains('cart-loading')) return;

      this.onCartLoadStart();
      this.onCartAdd(e);
    });

    document.addEventListener('cart:remove', (e) => {
      if (this.body.classList.contains('cart-loading')) return;

      this.onCartLoadStart();
      this.onCartRemove(e);
    });

    document.addEventListener('cart:updated', () => {
      this.onCartLoadEnd();
    });

    document.addEventListener('qty:change', (e) => {
      if (this.body.classList.contains('cart-loading')) return;

      this.onCartLoadStart(true);
      this.onCartUpdate(e, true);
    });
  }

  onCartAdd(e) {
    const formData = e.detail.data.formData;
    const max = parseInt(e.detail.data.max);
    const config = fetchConfig('javascript');
    const isCartPage = window.location.pathname === routes.cart_url;
    let id = '';
    let quantity = 1;
    let max_reached = false;

    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    for (const pair of formData.entries()) {
      if (pair[0] === 'id') {
        id = pair[1];
      }

      if (pair[0] === 'quantity') {
        quantity = pair[1];
      }
    }

    config.body = formData;
    
    document.dispatchEvent(
      new CustomEvent('cart:requestStart')
    );

    document.dispatchEvent(
      new CustomEvent('alert:clear')
    );

    fetch(`${routes.cart_url}.json`)
    .then((res) => {
      return res.json();
    })
    .then((cart) => {
      cart.items.forEach((item) => {
        if (item.id === parseInt(id)) {
          if (item.quantity + parseInt(quantity) > max) {
            document.dispatchEvent(
              new CustomEvent('alert:show', { 
                detail: {
                  data: {
                    message: `${cartStrings.limit.replace('[max]', max).replace('[product]', item.title)}`,
                    status: 'Error'
                  }
                }
              })
            );
            max_reached = true;
            this.onCartLoadEnd();
          }
        }
      });

      if (!max_reached) {
        fetch(`${routes.cart_add_url}`, config)
        .then((res) => {
          if (!res.ok) {
            res.json()
            .then((error) => {
              document.dispatchEvent(
                new CustomEvent('alert:show', { 
                  detail: {
                    data: {
                      message: `${cartStrings.error_label} ${error.description}`,
                      status: 'Error'
                    }
                  }
                })
              );
              
              this.onCartLoadEnd();
              throw new Error(error.description);
            })
          } else {
            res.json()
            .then(() => {
              fetch(`${routes.cart_url}.json`)
              .then((res) => {
                return res.json();
              })
              .then((cart) => {
                fetch(`/?sections=${e.detail.data.sections}`)
                .then((res) => {
                  return res.text();
                })
                .then((section) => {
                  if (!isCartPage) {
                    document.dispatchEvent(
                      new CustomEvent('popout-cart:show')
                    );
                  }
                  
                  document.dispatchEvent(
                    new CustomEvent('cart:requestComplete', { 
                      detail: {
                        data: {
                          ...cart,
                          sections: JSON.parse(section)
                        }
                      }
                    })
                  )
                })
              })
            })
            .catch(() => {
              this.onCartLoadEnd();
        
              document.dispatchEvent(
                new CustomEvent('alert:show', { 
                  detail: {
                    data: {
                      message: cartStrings.error,
                      status: 'Error'
                    }
                  }
                })
              );
            })
          }
        })
      }
    })
  }

  onCartRemove(e) {
    const key = e.detail.key;
    const sections = ['stmt-popout-cart-delivery-banner','stmt-popout-cart-items', 'stmt-popout-cart-footer'];
  
    if (key) {
      const body = JSON.stringify(
        {
          id: key,
          quantity: 0,
          sections: sections
        }
      )
      this.cartRequest(routes.cart_change_url, body);
    } else {
      this.onCartLoadEnd();
    }
  }

  onCartUpdate(e, qtyChange) {
    const key = e.detail.key;
    const quantity = e.detail.quantity;
    const sections = ['stmt-popout-cart-items', 'stmt-popout-cart-delivery-banner', 'stmt-popout-cart-footer'];
 
    if (key && quantity >= 0) {
      const body = JSON.stringify(
        {
          id: key,
          quantity: quantity,
          sections: sections
        }
      )

      this.cartRequest(routes.cart_change_url, body, qtyChange);
    } else {
      this.onCartLoadEnd();
    }
  }

  cartRequest(route, body, qtyChange) {
    document.dispatchEvent(
      new CustomEvent('cart:requestStart', {
        detail: {
          qtyChange
        }
      })
    )
    fetch(route, {...fetchConfig(), ...{ body }})
    .then((res) => {
      return res.text()
    })
    .then((data) => {
      document.dispatchEvent(
        new CustomEvent('cart:requestComplete', { 
          detail: {
            qtyChange,
            data: JSON.parse(data)
          }
        })
      )
    })
    .catch((e) => {
      console.error(e);
      this.onCartLoadEnd();
    })
  }

  onCartLoadStart(qtyChange) {
    if (qtyChange) {
      this.body.classList.add('cart-qty-loading');
      return;
    }

    this.body.classList.add('cart-loading');
  }

  onCartLoadEnd() {
    const isLoading = document.querySelectorAll('.is-loading');

    this.body.classList.remove('cart-loading', 'cart-qty-loading');

    isLoading.forEach((el) => {
      el.classList.remove('is-loading')
    })
  }
}

new CartEvents();